module.exports = __webpack_public_path__ + "img/2.f55af1d7.jpg";